<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>代理</el-breadcrumb-item>
			<el-breadcrumb-item>钱包</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="margin-t-20 flex justify-content-s-b">
			<el-form :inline="true" :model="queryForm" size="small">
				<el-form-item>
					<el-input v-model="queryForm.keyword" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryForm.status" placeholder="标题">
						<el-option label="区域一" value="shanghai"></el-option>
						<el-option label="区域二" value="beijing"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary">查询</el-button>
					<el-button type="infor">刷新</el-button>
				</el-form-item>
			</el-form>
		</div>

		<div class="flex">
			<div class="summary-item">
				<p>预估佣金</p>
				<p>1000.00</p>
			</div>
			<div class="summary-item">
				<p>预估佣金</p>
				<p>1000.00</p>
			</div>
			<div class="summary-item">
				<p>预估佣金</p>
				<p>1000.00</p>
			</div>
			<div class="summary-item">
				<p>预估佣金</p>
				<p>1000.00</p>
			</div>
		</div>

		<div class="margin-t-20">
			<el-table :data="tableData" border style="width: 100%" max-height="500">
				<el-table-column type="index" label="序号" width="80">
				</el-table-column>
				<el-table-column prop="name" label="订单信息">
				</el-table-column>
				<el-table-column prop="address" label="可提佣金">
				</el-table-column>
				<el-table-column prop="address" label="交易类型">
				</el-table-column>
				<el-table-column prop="address" label="收支类型">
				</el-table-column>
				<el-table-column prop="address" label="当前总余额">
				</el-table-column>
				<el-table-column prop="address" label="当前可用余额">
				</el-table-column>
				<el-table-column prop="address" label="当前审核中佣金">
				</el-table-column>
				<el-table-column prop="address" label="备注">
				</el-table-column>
			</el-table>
		</div>

		<div class="margin-t-10 flex">
			<el-pagination background layout="prev, pager, next, jumper" :total="total"
				:current-page.sync="queryForm.page" @current-change="handleCurrentPageChange">
			</el-pagination>
			<el-button size="small">确定</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Wallet',
		data() {
			return {
				total: 0,

				queryForm: {
					page: 1,
				},

				tableData: [{
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-04',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1517 弄'
				}, {
					date: '2016-05-01',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1519 弄'
				}, {
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄'
				}]
			}
		},
		methods: {
			handleCurrentPageChange() {

			}
		}
	}
</script>

<style lang="less" scoped>
	.summary-item {
		margin-left: -1px;
		border: 1px solid #EBEEF5;
		padding: 10px 40px;
		text-align: center;
		background: #F4F6F8;
	}
</style>
